"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LoadingSpinner = require("./LoadingSpinner");

var variantTypeToIconTypeMapping = {
  info: 'info',
  success: 'answer',
  warning: 'warning',
  danger: 'warning',
  loading: 'loadingSpinner'
};

var Message = function Message(_ref) {
  var text = _ref.text,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      title = _ref.title,
      children = _ref.children,
      fullWidth = _ref.fullWidth,
      _ref$hideIcon = _ref.hideIcon,
      hideIcon = _ref$hideIcon === void 0 ? false : _ref$hideIcon,
      icon = _ref.icon,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
      style = _ref.style;
  var baseClass = 'panel-form-information';
  var className = (0, _classnames.default)(baseClass, variant ? "".concat(baseClass, "--").concat(variant) : "".concat(baseClass, "--secondary"), fullWidth && "".concat(baseClass, "--fullWidth"), customClass);
  var hasChildren = Array(children).toString() !== '';
  var defaultIcon = icon !== null && icon !== void 0 ? icon : (0, _preact.h)(_assets.default, {
    icon: variantTypeToIconTypeMapping[variant],
    width: 20,
    height: 20,
    customClass: "icon-".concat(variantTypeToIconTypeMapping[variant])
  });
  return (0, _preact.h)("div", {
    className: className,
    style: style
  }, !hideIcon && (0, _preact.h)("div", {
    className: "panel-form-information__icon-box"
  }, variant === 'loading' ? (0, _preact.h)(_LoadingSpinner.LoadingSpinner, {
    width: 20,
    height: 20
  }) : defaultIcon), (0, _preact.h)("div", null, title ? (0, _preact.h)("h4", {
    className: "panel-form-information__title"
  }, (0, _preact.h)("strong", null, title)) : '', hasChildren ? children : (0, _preact.h)("div", {
    className: "panel-form-text"
  }, text)));
};

exports.Message = Message;